import React from "react";
import { GenerateTweets, getBestTweets } from "components/generate-canva/generateTweets";
import safeJsonStringify from 'safe-json-stringify';

let indexExclusionList = [
    "TheAlexaPowell"
]

const GeneratePublic = ({twUserName, bestTweets}) => {

    let desc = "Generate tweets with AI with the same style than anyone on Twitter";
    let subtitle = "Choose a Twitter creator and generate tweets on the same tone and same topic with our AI Twitter Tool";

    if (twUserName) {
        desc = "Generate tweets with AI that @" + twUserName + " could have written but actually didn't - free Twitter tool by Tweet Hunter";
        subtitle = "Generate tweets on the same tone and same topic than @" + twUserName + " with our AI Twitter Tool";
    }

    return (
        <GenerateTweets 
            twUserName={twUserName ?? ""}
            title={"Generate Tweets like @" + twUserName + " with AI"}
            subtitle={subtitle}
            desc={desc}
            url={"https://tweethunter.io/generate-tweets/" + (twUserName ?? "")}
            image={`https://ondemand.bannerbear.com/simpleurl/9MOpzJ843LWBnGWYvq/image/title/text/Generate%20tweets%20like%20@${twUserName}`}
            bestTweets={bestTweets}
            noIndex={twUserName && indexExclusionList.includes(twUserName)}
        />
    );
};

export async function getServerSideProps({ params, res }) {

    let bestTweets = await getBestTweets();
  
    let props = {twUserName: params?.twUserName, bestTweets};
    
    res.setHeader('Cache-Control', 'public, max-age=21600, stale-while-revalidate=604800'); // 1min - 7 days
    
    const stringifiedData = safeJsonStringify(props);
    props = JSON.parse(stringifiedData);
  
    return {
        props: props,
    };
}

export default GeneratePublic;